import { ISignUpModal } from 'common/types';
import { urlConstants } from 'common/utils/constants';

import { authApi } from '../api/Axios';

export const signUp = (payload: ISignUpModal) =>
  authApi.post(urlConstants.signUp_url, payload);
